export default __webpack_public_path__ + "53fb7b4935307c153b9d45bdfea7a209.svg";